import { render, staticRenderFns } from "./Landanalysis.vue?vue&type=template&id=138f5871&scoped=true&"
import script from "./Landanalysis.vue?vue&type=script&lang=js&"
export * from "./Landanalysis.vue?vue&type=script&lang=js&"
import style0 from "./Landanalysis.vue?vue&type=style&index=0&id=138f5871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f5871",
  null
  
)

export default component.exports